export { default } from './PartiuGpHeader';
